/** B2B insight articles — attract buyers who hire Homvisit */
export const b2bArticles = [
  {
    slug: 'how-to-outsource-home-blood-collection-kerala',
    title: 'Outsource Home Blood Collection in Kerala | Homvisit',
    h1: 'How to Outsource Home Blood Collection in Kerala',
    description: 'A buyer’s guide to outsourcing home blood collection in Kerala — SLAs, quality metrics, coverage, and partner models. Homvisit serves labs, hospitals, and HR…',
    date: '2026-08-07',
    sections: [
      {
        heading: 'Why labs outsource collection',
        paragraphs: [
          'Building a statewide home-collection team is expensive. Outsourcing lets diagnostic brands expand Kerala coverage while focusing capital on lab quality and branding.',
        ],
      },
      {
        heading: 'What to put in the partner brief',
        paragraphs: [
          'Define cities, expected daily volumes, SLA windows, branding rules, tube menus, and rejection definitions. Ambiguity here becomes field chaos later.',
        ],
      },
      {
        heading: 'Quality metrics that matter',
        paragraphs: [
          'Track on-time arrival, unsuccessful visit rate, labelling errors, haemolysed samples, and patient complaints — not just “visits completed”.',
        ],
      },
      {
        heading: 'How Homvisit helps',
        paragraphs: [
          'Homvisit operates as a Kerala collection partner with an always-developing phlebotomist network and camp/home hybrid capability.',
        ],
      },
    ],
    related: ['/services/home-blood-collection', '/services/home-collection-network'],
  },
  {
    slug: 'corporate-health-camps-planning-checklist',
    title: 'Corporate Health Camps Planning Checklist | Homvisit',
    h1: 'Corporate Health Camps: Planning Checklist',
    description: 'Plan corporate health camps in Kerala with a practical checklist — communication, staffing, fasting, and dispatch. Homvisit serves labs, hospitals, and HR…',
    date: '2026-08-07',
    sections: [
      {
        heading: 'Six weeks out',
        paragraphs: [
          'Lock dates with leadership, choose diagnostic partner packages, and estimate headcount by shift.',
        ],
      },
      {
        heading: 'Two weeks out',
        paragraphs: [
          'Book phlebotomy staffing, circulate pre-test instructions, and finalise venue layout.',
        ],
      },
      {
        heading: 'Camp week',
        paragraphs: [
          'Confirm consumables, backup phlebotomists, and sample pickup time. Brief volunteers/HR desk on ID flow.',
        ],
      },
    ],
    related: ['/resources/health-camp-checklist', '/services/corporate-health-camps'],
  },
  {
    slug: 'choosing-phlebotomy-partner-diagnostic-lab',
    title: 'Choosing a Lab Phlebotomy Partner | Homvisit Kerala',
    h1: 'Choosing a Phlebotomy Partner for Your Diagnostic Lab',
    description: 'How diagnostic labs in Kerala should evaluate a phlebotomy / sample collection partner. Homvisit serves labs, hospitals, and HR teams across Kerala.',
    date: '2026-08-07',
    sections: [
      {
        heading: 'Coverage vs control',
        paragraphs: [
          'In-house teams give control; partners give speed. Many labs blend both — own the core city, partner for overflow and new districts.',
        ],
      },
      {
        heading: 'Questions to ask',
        paragraphs: [
          'Ask about training, SOP customisation, white-label options, camp experience, and how rejects are reviewed.',
        ],
      },
    ],
    related: ['/services/diagnostic-lab-partner', '/services/white-label-phlebotomy'],
  },
  {
    slug: 'cold-chain-integrity-sample-transport',
    title: 'Cold-Chain Integrity in Sample Transport | Homvisit',
    h1: 'Maintaining Cold-Chain Integrity During Sample Transport',
    description: 'Practical notes on cold-chain integrity for blood samples collected in Kerala’s climate. Homvisit serves labs, hospitals, and HR teams across Kerala.',
    date: '2026-08-07',
    sections: [
      {
        heading: 'Know which tests care',
        paragraphs: [
          'Temperature sensitivity varies. Align with your lab’s pre-analytical manual before promising ice-free logistics.',
        ],
      },
      {
        heading: 'Field realities in Kerala',
        paragraphs: [
          'Heat, traffic, and multi-stop routes create risk. Design routes and handoff times deliberately — especially for large camps.',
        ],
      },
    ],
    related: ['/how-it-works/cold-chain-management', '/how-it-works/sample-transport'],
  },
  {
    slug: 'how-hospitals-scale-home-collection',
    title: 'How Hospitals Scale Home Collection | Homvisit Kerala',
    h1: 'How Hospitals Can Scale Home Collection Services',
    description: 'Models for hospitals scaling home sample collection in Kerala without overloading permanent staff. Homvisit serves labs, hospitals, and HR teams across Kerala.',
    date: '2026-08-07',
    sections: [
      {
        heading: 'Start with a corridor',
        paragraphs: [
          'Pilot 1–2 high-demand pin codes before statewide promises. Measure turnaround and complaint rates.',
        ],
      },
      {
        heading: 'Partner for elasticity',
        paragraphs: [
          'Use a collection partner for peaks (camps, seasonal demand) while hospital staff handle complex inpatient workflows.',
        ],
      },
    ],
    related: ['/services/home-collection-network', '/services/healthcare-staffing'],
  },
  {
    slug: 'cost-of-outsourcing-phlebotomy-kerala',
    title: 'Cost of Outsourcing Phlebotomy in Kerala | Homvisit',
    h1: 'Cost of Outsourcing Phlebotomy in Kerala',
    description: 'What drives the cost of outsourcing phlebotomy in Kerala — volume, geography, camp vs home, and SLA tightness. Homvisit serves labs, hospitals, and HR teams…',
    date: '2026-08-07',
    sections: [
      {
        heading: 'Cost drivers',
        paragraphs: [
          'Per-draw pricing, minimum camp fees, travel for remote districts, night/early slots, and white-label requirements all affect cost.',
        ],
      },
      {
        heading: 'How to compare quotes fairly',
        paragraphs: [
          'Compare total cost of quality — redraws and brand damage are expensive. Cheap collection with high rejects is not cheap.',
        ],
      },
      {
        heading: 'Talk to Homvisit',
        paragraphs: [
          'Share expected monthly volume and districts for a practical commercial discussion — call 75 9409 9409.',
        ],
      },
    ],
    related: ['/services/phlebotomy-services-kerala', '/services/healthcare-staffing'],
  },
  {
    slug: 'best-practices-preventive-health-screening',
    title: 'Preventive Health Screening Best Practices | Homvisit',
    h1: 'Best Practices for Preventive Health Screening Programs',
    description: 'Best practices for employer preventive health screening — communication, consent, logistics, and follow-up. Homvisit serves labs, hospitals, and HR teams…',
    date: '2026-08-07',
    sections: [
      {
        heading: 'Design for participation',
        paragraphs: [
          'Onsite camps beat optional offsite visits. Offer multiple slots and clear fasting guidance.',
        ],
      },
      {
        heading: 'Respect privacy',
        paragraphs: [
          'Results should flow through appropriate clinical channels — not casual WhatsApp groups.',
        ],
      },
      {
        heading: 'Operational excellence',
        paragraphs: [
          'Invest in phlebotomy capacity and queue design; a bad camp experience reduces next year’s participation.',
        ],
      },
    ],
    related: [
      '/resources/corporate-health-screening-guide',
      '/services/corporate-health-checkups',
    ],
  },
]

export function getB2bArticle(slug) {
  return b2bArticles.find((a) => a.slug === slug) || null
}
